import axios from 'axios'
import  { checkErrorData } from './authAction'

export function newUser(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_USER_START", payload: "" })

            console.log("new User START", {data})
            const res = await axios.post('/users/new',{data})
            console.log({res});
            
            if (checkErrorData(res, "CREATE_USER_ERROR", dispatch) ){
                dispatch({
                    type: "NEW_USER",
                    payload: res.data
                })
                dispatch({ type: "CREATE_USER_FULFILLED", payload: "" })

            } 
        } catch(err) {
            console.log("[ERROR] new user ", err);
            dispatch({
                type: "CREATE_USER_ERROR",
                payload: err
            })
        }
    }
}
export function fetchUsers() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USERS_START", payload: "" })
            console.log("fetch User START")
            const res = await axios.get('/users/all')
            console.log({res});  
          
            if ( checkErrorData(res, "FETCH_USERS_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_USERS",
                    payload: formatList(res.data, "user_id")
                })
                dispatch({ type: "FETCH_USERS_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] get users list ", err);
            dispatch({ type: "FETCH_USERS_ERROR", payload: "" })
        }
    }
}

export function fetchUsersByEmail(email) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USERS_START", payload: "" })
            console.log("fetch User START")
            const res = await axios.get('/usersV2?whereQuery=email='+email)
            console.log("========RESPONSE USER BY EMAIL========");
            console.log(res);
          
            if ( checkErrorData(res, "FETCH_USERS_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_USERS",
                    payload: formatList(res.data, "user_id")
                })
                dispatch({ type: "FETCH_USERS_FULFILLED", payload: "" })
            }
            return "ok"
        } catch(err) {
            console.log("[ERROR] get users list ", err);
            dispatch({ type: "FETCH_USERS_ERROR", payload: "" })
        }
    }
}
export function updateUser(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_USER_START", payload: "" })

            console.log("update User START")
            const res = await axios.post("/users/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_USER_ERROR", dispatch) ){ 
                dispatch({
                    type: "UPDATE_USER",
                    payload: data
                })
                dispatch({ type: "UPDATE_USER_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update user ", err);
            dispatch({
                type: "UPDATE_USER_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateUserPassword(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_USER_PASS_START", payload: "" })

            console.log("update User START")
            const res = await axios.post("/users/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_USER_PASS_ERROR", dispatch) ){ 
                dispatch({ type: "UPDATE_USER_PASS_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update user ", err);
            dispatch({
                type: "UPDATE_USER_PASS_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteUser(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "DELETE_USER_START", payload: "" })

            console.log("delete User START")
            const res = await axios.post("/users/delete", {data: data.user_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_USER_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_USER",
                    payload: data
                })
                dispatch({ type: "DELETE_USER_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete user ", err);
            dispatch({
                type: "DELETE_USER_ERROR",
                payload: err
            })
        }
    }
}

function formatList(list, field = "id"){
    let newList = {}
    if (list) {
        list.map((item)=>{
            delete item.password
            newList[item[field]] = item
        })
    }
    return newList
}

export function fetchSociety() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SOCIETY_START", payload: "" })
            console.log("fetch Society START")
            const res = await axios.get('/users/society/get')
            console.log({res});  
          
            if ( checkErrorData(res, "FETCH_SOCIETY_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_SOCIETY",
                    payload: res.data
                })
                dispatch({ type: "FETCH_SOCIETY_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] get society list ", err);
            dispatch({ type: "FETCH_SOCIETY_ERROR", payload: "" })
        }
    }
}
export function newSociety(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SOCIETY_START", payload: "" })
            console.log("new Society START", {data})
            const res = await axios.post('/users/society/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_SOCIETY_ERROR", dispatch ) ) {
                let newData = Object.assign({}, res.data)
                dispatch({ type: "NEW_SOCIETY", payload: newData })
				dispatch({ type: "CREATE_SOCIETY_FULFILLED", payload: "" })
            }
            
        } catch(err) {
            console.log("[ERROR] new society ", err);
            dispatch({
                type: "CREATE_SOCIETY_ERROR",
                payload: err
            })
        }
    }
}